import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonCard } from "./styled";

const HorizontalCarouselSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      <SkeletonCard />
    </ModuleSkeleton>
  );
};

export default HorizontalCarouselSkeleton;
